
    import Vue from 'vue';

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    
export const RENEW_MODULE = {
  1: $t('6450b3'),
  2: $t('5da351'),
  4: $t('731948'),
  8: $t('9abb56'),
}
